import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { FormattedMessage } from 'sb-react-intl'
import { constants } from 'common/helpers'

import Button from 'components/buttons/Button/Button'

import messages from './messages'
import s from './MonthsButton.scss'


class MonthsButton extends Component {

  static propTypes = {
    className: PropTypes.string,
    active: PropTypes.bool,
    count: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
  }

  handleClick = () => {
    const { count, onClick } = this.props
    onClick(count)
  }

  render() {
    const { className, active, count } = this.props

    const rootClassName = cx(className, {
      [s.inactive]: !active,
    })

    return (
      <Button
        className={rootClassName}
        lg
        noPadding
        fullWidth
        brand={active}
        whiteBrand={!active}
        onClick={this.handleClick}
        dataTestId={constants.testIds.skipAMonth.optionButton}
      >
        <div className={s.content}>
          <div className={s.count}>{count}</div>
          <FormattedMessage className={s.text} {...{ ...messages.title, values: { count } }} />
        </div>
      </Button>
    )
  }
}

export default MonthsButton
